<template>
  <div class="template-account-menu">
    <b-dropdown
      variant="link"
      toggle-class="text-decoration-none text-secondary"
      right
      no-caret
    >
      <template v-slot:button-content>
        <div
          class="account-picture"
          :style="`background-image: url(${$user.user.picture})`"
        >
          <i v-if="!$user.user.picture" class="fas fa-user"></i>
        </div>
      </template>

      <b-dropdown-item :to="{ name: 'account' }">
        Perfil e assinatura
      </b-dropdown-item>
      <b-dropdown-item
        v-for="course in courses"
        :key="course.id"
        :to="{ name: 'short-course', params: { id: course.id } }"
      >
        {{ course.name }}
      </b-dropdown-item>
      <b-dropdown-item @click="$emit('logout')">
        Sair
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { get } from "lodash";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("courses", ["microlearnings"]),
    courses() {
      return this.$user.user.enrollments
        .filter(e => e.microlearning)
        .map(e => ({
          id: e.microlearning,
          name: get(
            this.microlearnings.find(m => m.id === e.microlearning),
            "title"
          )
        }));
    }
  }
};
</script>

<style lang="scss" scoped>
.template-account-menu {
  .account-icon {
    font-size: 20px;
  }

  ::v-deep .dropdown-toggle {
    padding-right: 0;

    &::after {
      display: none;
    }
  }

  ::v-deep .account-picture {
    background-color: #818181;
    background-size: cover;
    background-position: center center;
    height: 32px;
    width: 32px;
    border-radius: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
}
</style>
